import axios from "axios";
import { del, get, post, patch,  put } from "./departments_api_helper";
import * as url from "./departments_url_helper";





// Get features
export const getDepartments = () => get(url.GET_DEPARTMENTS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewDepartment = department => post(url.ADD_NEW_DEPARTMENT, department, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateDepartment = department => patch(`${url.UPDATE_DEPARTMENT}/${department.id}`,  department);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteDepartment = department => del(`${url.DELETE_DEPARTMENT}/${department.id}`);







export {
  //getLoggedInUser,
  
  
};
